import React, { Component } from 'react';
import { FlatList, Keyboard, Platform } from 'react-native';

import OPComponent from './op_component';

export default class KeyboardAvoidingFlatList extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      keyboardHeight: 0,
    };
  }

  componentDidMount() {
    this._addKeyboardEventListeners();
  }

  componentWillUnmount() {
    this._removeKeyboardListeners();
  }

  /** Following four methods are heavily inspired by react-native-keyboard-aware-scrollview **/
  /** would be best to factor into a reusable component **/
  _addKeyboardEventListeners() {
    if (Platform.OS === 'ios') {
      this.keyboardEventListeners = [
        Keyboard.addListener('keyboardWillShow', this._onKeyboardWillShow.bind(this)),
        Keyboard.addListener('keyboardWillHide', this._onKeyboardWillHide.bind(this)),
      ];
    } else {
      // this is not needed for Android because in android flatlist already handles
      // keyboard spacing
      this.keyboardEventListeners = [];
      // this.keyboardEventListeners = [
      //   Keyboard.addListener(
      //     'keyboardDidShow',
      //     this._onKeyboardWillShow.bind(this)
      //   ),
      //   Keyboard.addListener(
      //     'keyboardDidHide',
      //     this._onKeyboardWillHide.bind(this)
      //   ),
      // ];
    }
  }
  _removeKeyboardListeners() {
    this.keyboardEventListeners.forEach(eventListener => eventListener.remove());
  }
  _onKeyboardWillShow(event) {
    const newKeyboardHeight = event.endCoordinates.height;
    if (this.state.keyboardHeight === newKeyboardHeight) {
      return;
    }
    this.setState({ keyboardHeight: newKeyboardHeight });
  }
  _onKeyboardWillHide(event) {
    this.setState({ keyboardHeight: 0 });
  }

  render() {
    let contentContainerStyle = this.props.contentContainerStyle
      ? [this.props.contentContainerStyle]
      : [];
    const extraPadding = this.props.extraPadding || 0;
    contentContainerStyle.push({
      paddingBottom: this.state.keyboardHeight + extraPadding,
    });

    return (
      <FlatList
        keyboardShouldPersistTaps={this.props.keyboardShouldPersistTaps || 'handled'}
        automaticallyAdjustContentInsets={false}
        contentContainerStyle={contentContainerStyle}
        ItemSeparatorComponent={this.props.ItemSeparatorComponent}
        data={this.props.data}
        renderItem={this.props.renderItem}
        keyExtractor={this.props.keyExtractor}
      >
        {this.props.children}
      </FlatList>
    );
  }
}
